/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
//フッターSPの開閉リンク
const myApp = {}
myApp.accordion = function () {
  if ($(".js-accordion").length) {

    $(".js-accordion").each(function () {      
      var parent = $(this);      
      parent.find(".js-accordion-toggle").on("click", function () {
        var button = $(this);
        if (parent.hasClass("is-active")) {
          button.removeClass("is-active");
          parent.removeClass("is-active");
          parent.find(".js-accordion-target").slideUp(300);
        } else {
          button.addClass("is-active");
          parent.addClass("is-active");
          parent.find(".js-accordion-target").slideDown(300);
        }
        return false;
      });
    });
  }
};
myApp.accordion()

//コレクションリストサイドバーの開閉リンク
$(function () {
  $(".CollectionMenu__List--Link span.plus").on({
    click: function () {
      $(this).toggleClass("active");
      $(this)
        .parent("div")
        .next("ul")
        .slideToggle(400);
      return false;
    },
  });
});

$(document).ready(function(){
  var item = $(".CustomBannerBlock");
  $(item).addClass("-visible");
  
  $('.CustomBanner__Filter--Item').on('click', function() {
    $('.CustomBanner__Filter--Item').removeClass("CustomBanner__Filter--current");
    $(this).addClass("CustomBanner__Filter--current");
    
    var selectedCategory = $(this).data("category");
    console.log(selectedCategory);
    
    $(item).removeClass("-visible");
    setTimeout(function(){
      $(item).each(function(){
        var category = $(this).data("category");
        if (category == selectedCategory) {
          $(this).addClass("-visible");
        } else {
          $(this).removeClass("-visible");
        }
        if (selectedCategory == "all") {
          $(this).addClass("-visible");
        }
      });
    },100);
  });
  
  
});